import { IFeed } from "@/types/IFeed";
import { createSlice } from "@reduxjs/toolkit";

export type stateType = {
  post: IFeed;
  replies: IFeed[];
};

const initialState: stateType = {
  post: {} as IFeed,
  replies: [],
};
export const PostDetailSlice = createSlice({
  name: "post_detail_slice",
  initialState,
  reducers: {
    //post
    addPost: (state, action) => {
      state.replies = []
      state.post = action.payload;
    },
    quote: (state) => {
      state.post.amountV2Quotes = state.post.amountV2Quotes + 1;
    },
    repost: (state, action) => {
      state.post.amountV2Reposts =
        action.payload === -1
          ? state.post.amountV2Reposts - 1
          : state.post.amountV2Reposts + 1;
      state.post.repostedByMe = action.payload === -1 ? 0 : 1;
    },
    // replies
    insert: (state, action) => {
      state.replies = [action.payload, ...state.replies];
    },
    pushReplies: (state, action) => {
      state.replies = state.replies.concat(action.payload);
    },
    reset: (state) => {
      state.replies = [];
    },
    deleteReply: (state, action) => {
      const index = state.replies.findIndex(
        (comment) => comment.id === action.payload
      );
      state.replies.splice(index, 1);
    },
    likeUnlikeDetailPost: (state, action) => {
      if(state.post && state.post.id === action.payload){
        state.post.liked = state.post.liked === 0 ? 1 : 0;
        state.post.amountLikes = state.post.liked === 0 ? state.post.amountLikes - 1 : state.post.amountLikes + 1;
      }
    }
  },
});

export const {
  addPost,
  quote,
  insert,
  repost,
  pushReplies,
  reset,
  deleteReply,
  likeUnlikeDetailPost
} = PostDetailSlice.actions;

export default PostDetailSlice.reducer;
